export var ModifyShotLocation = {
  name: "modify_shot_location",
  component: "MainPanel",
  layout: "main-panel large align-center",
  mode: "visible",
  text: "edit.shot.location-modify",
  showOn: [{ state: "editState", value: "shot_location", operator: "is" }],
  allowFlag: true,
  allowCancel: true,
  showDetails: { events: ["edit"] },
  children: [
    {
      name: "change_shot_location_description",
      component: "PanelText",
      layout: "panel-text",
      mode: "visible",
      showOn: [true],
      options: {
        layout: "description-text",
        text: "edit.shot.location",
      },
      actionGroups: [],
    },
    {
      name: "location_map",
      component: "MiniLocation",
      layout: "basketball",
      mode: "visible",
      showOn: [true],
      options: {
        layout: "description-text",
        text: "edit.shot.location",
        needConfirmation: true,
        positionBasedRegion: true,
        checkAllowedValues: false,
      },
      actionGroups: [
        {
          actions: [
            {
              action: "sendEvent",
              value: "edit",
              type: "edit",
            },
            {
              action: "nextState",
              value: null,
              type: "editState",
            },
          ],
          conditions: [],
        },
      ],
    },
  ],
};
